import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
  selector: '[payUnique][formControlName],[payUnique][formControl],[payUnique][ngModel]',
  providers: [{ provide: NG_VALIDATORS, useExisting: UniqueDirective, multi: true }]
})

export class UniqueDirective implements Validator {

  @Input()
  payUnique: Array<any>;

  @Input()
  payInitialValue: string;

  validate(ctrl: AbstractControl):  { [key: string]: any } {
    if(ctrl.value == this.payInitialValue) {
      return null;
    } else {
      return this.payUnique.indexOf(ctrl.value) > -1 ?  { "payUnique": true } : null;
    }    
  }
} 



// WEBPACK FOOTER //
// ./src/directives/unique-validator.directive.ts